<template>
    <rkm-modal
        :buttons="['cancel']"
        large
        persistent
        ref="RkmModal"
        title="Detalhamento do cancelamento"
        v-if="pacienteExists"
    >
        <rkm-alert show info>
            <p>
                <strong>{{ data.form.paciente.cidadao.nome }}</strong>
            </p>
            <p>
                <strong>Idade:</strong>
                    <template v-if="data.form.paciente.cidadao.idade">
                    {{ data.form.paciente.cidadao.idade.anos }} anos,
                    {{ data.form.paciente.cidadao.idade.meses }} meses e
                    {{ data.form.paciente.cidadao.idade.dias }} dias
                    </template>
                <template v-else>
                -
                </template> -
                <strong>Prontuário: </strong>{{ data.form.paciente.prontuario }}
            </p>
        </rkm-alert>

        <rkm-row>
            <rkm-col>
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <td><strong>Agendamento:</strong></td>
                            <td>{{cancelamento.agendamentoNumero}}</td>
                        </tr>
                        <tr v-if="cancelamento.urgente == true">
                            <td><strong>Urgente</strong></td>
                            <td>Sim</td>
                        </tr>
                        <tr v-else>
                            <td><strong>Urgente</strong></td>
                            <td>Não</td>
                        </tr>
                        <tr>
                            <td><strong>Data do agendamento:</strong></td>
                            <td>{{cancelamento.data}} ás {{cancelamento.horaExame}}</td>
                        </tr>
                        <tr>
                            <td><strong>Grupo de exame:</strong></td>
                            <td>{{cancelamento.grupoExameNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Exame(s) incluído(s):</strong></td>
                            <td> {{examesIncluido()}} </td>
                        </tr>
                        <tr>
                            <td><strong>Médico solicitante:</strong> </td>
                            <td>{{cancelamento.medicoNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Profissional executante:</strong></td>
                            <td>{{cancelamento.profissionalNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Unidade executante:</strong> </td>
                            <td>{{cancelamento.unidadeNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Local de atendimento:</strong></td>
                            <td>{{cancelamento.infraestruturaNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Observação:</strong></td>
                            <td>{{cancelamento.observacao}}</td>
                        </tr>
                        <tr>
                            <td><strong>Cancelado por:</strong></td>
                            <td>{{ quemCancelou() || '-' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Data/Hora cancelamento:</strong></td>
                            <td>{{ dataHoraCanceladoAgendamento() || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

export default {
    computed: {
        pacienteExists() {
            return this.data.form && this.data.form.paciente
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamento')
        }
    },
    data: () => ({
        items: [],
        cancelamento: {
            agendamentoNumero: null,
            data: null,
            grupoExameId: null,
            grupoExameNome: '',
            horaExame: '',
            urgente: false,
            infraestruturaId: null,
            infraestruturaNome: '',
            profissionalId: null,
            profissionalNome: '',
            unidadeId: null,
            unidadeNome: '',
            observacao: '',
            exames: [],
            medicoNome: '',
            medicoId: '',
        },
    }),
    methods: {
        quemCancelou() {

            let usuarioCancelado = ''

            if (this.cancelamento.exames && this.cancelamento.exames.length > 0) {

            const nomes = this.cancelamento.exames.map(usuario => usuario.usuarioCanceladoNome);

            const todosIguais = nomes.every(nome => nome === nomes[0]);

                if (todosIguais) {
                usuarioCancelado = nomes[0];
                } else {
                usuarioCancelado = nomes.join(', ');
                }
            }

            return usuarioCancelado;
        },
        dataHoraCanceladoAgendamento() {
            
            let dataHora = '';

            if (this.cancelamento.exames && this.cancelamento.exames.length > 0) {
                const datas = this.cancelamento.exames.map(hora => hora.dataHoraCancelado);

                const todasIguais = datas.every(d => d === datas[0]);

                if (todasIguais) {
                    dataHora = datas[0];
                } else {
                    dataHora = datas.join(', ');
                }
            }

            return dataHora;
        },
        examesIncluido(){

            let nomeExame = ''

            if (this.cancelamento.exames) {

                this.cancelamento.exames.forEach(exameNomeIncluido => {

                    if(!nomeExame){

                        nomeExame = exameNomeIncluido.nomeExame
                    } else {

                        nomeExame = nomeExame + ', ' + exameNomeIncluido.nomeExame
                    }
                })
            }

            return nomeExame
        },
        open(item) { 

            this.cancelamento.data = item.data.split("-").reverse().join("/")
            this.cancelamento.grupoExameNome = item.grupoExameNome
            this.cancelamento.agendamentoNumero = item.agendamentoNumero
            this.cancelamento.urgente = item.urgente
            this.cancelamento.horaExame = item.horaExame
            this.cancelamento.exames = item.exames
            this.cancelamento.medicoNome = item.medicoNome
            this.cancelamento.unidadeNome = item.unidadeNome
            this.cancelamento.infraestruturaNome = item.infraestruturaNome
            this.cancelamento.profissionalId = item.profissionalId
            this.cancelamento.profissionalNome = item.profissionalNome
            this.cancelamento.observacao = item.observacao

            this.items = []
            this.$refs.RkmModal.show()
        },
    },
    mixins: [ error, repository ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
</style>